import { v4 as uuid } from 'uuid';

import { setWsRegistration } from './actions';
import { IWsSessionEvent } from './types';
import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';
import { ETelemetryEvents } from '../../types/telemetry';
import { listenEventChannel, setSocketFailed, setSocketSucceed } from '../socket';

/**
 * Регистрация сессии по WS
 */
export const registerWsSession =
  (): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, telemetry }) => {
    const {
      session: { token },
      socket: { eventChannel, clientEvents },
    } = getState();

    if (!token) {
      return;
    }

    // uid события сессии
    const sessionUid = uuid();

    const wsSession: IWsSessionEvent = {
      sessionToken: token.sessionToken,
      type: EWsClientEventType.Session,
      uid: sessionUid,
      userId: token.userId,
    };

    clientEvents.set(wsSession.uid, {
      status: ERequestApiStatus.Pending,
      type: EWsClientEventType.Session,
    });

    try {
      await eventChannel.updateSession(wsSession);

      dispatch(setWsRegistration(sessionUid));

      dispatch(setSocketSucceed());
      dispatch(listenEventChannel());
    } catch (err) {
      dispatch(setSocketFailed());
      logger.error('Не удалось зарегистрировать сессию по вебсокету', err.message);
      telemetry.increment(ETelemetryEvents.ChatWsSessionFail);

      clientEvents.set(wsSession.uid, {
        status: ERequestApiStatus.Failed,
        type: EWsClientEventType.Session,
      });
    }
  };
